import * as React from 'react';
import {FormComponentProps} from "antd/lib/form";
import {Form} from 'antd';
import ClientContactsFormItem from "../common/contact/ClientContactsFormItem";
import locales from "../locales";
import SubmitCancelFormItem from "../common/form-items/SubmitCancelFormItem";
import {RentalDocumentType, ReturnalDocumentType} from "../api/dtos/dtos";
import {documentTypeToText} from "./dtos";
import CheckBoxFormItem from "../common/form-items/CheckBoxFormItem";
import {CheckboxChangeEvent} from "antd/lib/checkbox";

interface SendDocumentFormProps extends FormComponentProps {
  clientId: number;
  documentTypes: Array<RentalDocumentType | ReturnalDocumentType>;
  onFormCancel: () => void;
  onFormSubmit: (documentTypes: Array<RentalDocumentType | ReturnalDocumentType>, contactIds: number[]) => void;
}

interface SendDocumentFormState {
  disabled: boolean;
}

const FIELD_CONTACTS = 'contacts';

class SendChecklistForm extends React.Component<SendDocumentFormProps, SendDocumentFormState> {
  constructor(props: SendDocumentFormProps) {
    super(props);
    this.state = {
      disabled: true,
    };
  }

  public render(): React.ReactNode {
    const {clientId, documentTypes, form} = this.props;
    const {disabled} = this.state;

    return (
      <>
        <Form>
          <ClientContactsFormItem
            form={form}
            fieldId={FIELD_CONTACTS}
            required={true}
            disabled={false}
            label={locales.document_recipients}
            clientId={clientId}
            initialContactIds={[]}
          />

          {documentTypes.map((documentType) => {
            return (
              <div key={documentType}>
                <CheckBoxFormItem
                  form={form}
                  fieldId={documentType}
                  disabled={false}
                  label={documentTypeToText[documentType]}
                  initialValue={false}
                  required={false}
                  onChange={this.onCheckboxChange}
                />
              </div>
            );
          })}

        </Form>
        <SubmitCancelFormItem
          disabled={disabled}
          submitLabel={locales.document_send}
          onSubmit={this.onFormSubmit}
          onCancel={this.onFormCancel}
        />
      </>
    );
  }

  private onCheckboxChange = (e: CheckboxChangeEvent) => {
    const hasOtherChecked = this.props.documentTypes.some((docType) => {
      return this.props.form.getFieldValue(docType) && docType !== e.target.id;
    });

    this.setState({disabled: !e.target.checked && !hasOtherChecked});
  }


  private onFormSubmit = () => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const selectedTypes = this.props.documentTypes.filter((documentType) => values[documentType]);
        this.props.onFormSubmit(selectedTypes, values[FIELD_CONTACTS]);
      }
    });
  };

  private onFormCancel = () => {
    this.props.form.resetFields();
    this.props.onFormCancel();
  };
}

export default Form.create<SendDocumentFormProps>()(SendChecklistForm);


// WEBPACK FOOTER //
// ./src/document-sendout/SendDocumentForm.tsx